import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10b5618c")

_pushScopeId("data-v-10b5618c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "form",
    model: _ctx.formData,
    "label-width": "80px"
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form_item, {
        prop: "name",
        rules: [{ required: true,message: '请输入名称',trigger: 'blur' }],
        label: "名称"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.formData.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.name = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        prop: "categoryIds",
        rules: [{ required: true,message: '请输入分类',trigger: 'blur' }],
        label: "分类"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_cascader, {
            filterable: "",
            modelValue: _ctx.formData.categoryIds,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.categoryIds = $event)),
            options: _ctx.templateCategories,
            props: {value: 'id', label: 'name', checkStrictly: true}
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { class: "flex-center" }, {
        default: _withId(() => [
          _createVNode(_component_el_button, {
            class: "margin-right-10",
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withId(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
})